module.exports = __webpack_public_path__ + "img/logout@2x.1418b9f.png";